import { render, staticRenderFns } from "./AplicationTabComponent.vue?vue&type=template&id=35f6a1f4&scoped=true&"
import script from "./AplicationTabComponent.vue?vue&type=script&lang=js&"
export * from "./AplicationTabComponent.vue?vue&type=script&lang=js&"
import style0 from "./AplicationTabComponent.vue?vue&type=style&index=0&id=35f6a1f4&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f6a1f4",
  null
  
)

export default component.exports